import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

// curto é o rótulo usado na legenda do card do editor (TagInstagram, em Article-Details), que não
// tem espaço para a descrição completa exibida no select.
export const modos = [
    { value: 'full', label: 'Completo, com legenda', curto: 'Completo' },
    { value: 'compact', label: 'Compacto, sem legenda', curto: 'Compacto' },
    { value: 'image', label: 'Somente imagem', curto: 'Somente imagem' },
    { value: 'media', label: 'Somente mídia (vídeo/reel)', curto: 'Somente mídia' },
    { value: 'video', label: 'Vídeo com controles nativos', curto: 'Vídeo' },
    { value: 'link', label: 'Somente link', curto: 'Somente link' },
    { value: 'profile', label: 'Perfil', curto: 'Perfil' },
];

const InsertInstagram = (props) => {
    const { isOpen, toggle, handleModalInstagram } = props;

    const [url, setUrl] = useState('');
    const [mode, setMode] = useState('full');
    const [alt, setAlt] = useState('');
    const [showLink, setShowLink] = useState(true);
    const [videoUrl, setVideoUrl] = useState('');
    const [autoplay, setAutoplay] = useState(false);
    const [muted, setMuted] = useState(false);
    const [loop, setLoop] = useState(false);
    const [controls, setControls] = useState(true);
    const [preload, setPreload] = useState('metadata');

    useEffect(() => {
        if (!isOpen) {
            setUrl('');
            setMode('full');
            setAlt('');
            setShowLink(true);
            setVideoUrl('');
            setAutoplay(false);
            setMuted(false);
            setLoop(false);
            setControls(true);
            setPreload('metadata');
        }
    }, [isOpen]);

    const habilitaInserir = url.trim() !== '' && (mode !== 'video' || videoUrl.trim() !== '');

    const confirmar = () => {
        handleModalInstagram({ url, mode, alt, showLink, videoUrl, autoplay, muted, loop, controls, preload });
    };

    return (
        <Modal size="lg" isOpen={isOpen} toggle={toggle} returnFocusAfterClose={false}>
            <ModalHeader toggle={toggle}>Inserir Instagram</ModalHeader>
            <ModalBody>
                <div className="row">
                    <div className="col-12 py-2">
                        <label>URL do post/reel/perfil<sup><small>(*)</small></sup></label>
                        <input type="text" className="form-control" value={url} onChange={e => setUrl(e.target.value)} autoComplete="off" />
                    </div>
                    <div className="col-12 py-2">
                        <label>Modo de exibição</label>
                        <select className="form-control" value={mode} onChange={e => setMode(e.target.value)}>
                            {modos.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                        </select>
                    </div>

                    {mode === 'image' && (
                        <React.Fragment>
                            <div className="col-12 py-2">
                                <label>Texto alternativo (alt)</label>
                                <input type="text" className="form-control" value={alt} onChange={e => setAlt(e.target.value)} autoComplete="off" />
                            </div>
                            <div className="col-12 py-2">
                                <label>
                                    <input type="checkbox" checked={showLink} onChange={e => setShowLink(e.target.checked)} /> Exibir link para o post original
                                </label>
                            </div>
                        </React.Fragment>
                    )}

                    {mode === 'video' && (
                        <React.Fragment>
                            <div className="col-12 py-2">
                                <label>URL do arquivo de vídeo<sup><small>(*)</small></sup></label>
                                <input type="text" className="form-control" value={videoUrl} onChange={e => setVideoUrl(e.target.value)} autoComplete="off" />
                            </div>
                            <div className="col-6 py-2">
                                <label><input type="checkbox" checked={controls} onChange={e => setControls(e.target.checked)} /> Controles</label>
                            </div>
                            <div className="col-6 py-2">
                                <label><input type="checkbox" checked={autoplay} onChange={e => setAutoplay(e.target.checked)} /> Autoplay</label>
                            </div>
                            <div className="col-6 py-2">
                                <label><input type="checkbox" checked={muted} onChange={e => setMuted(e.target.checked)} /> Mudo</label>
                            </div>
                            <div className="col-6 py-2">
                                <label><input type="checkbox" checked={loop} onChange={e => setLoop(e.target.checked)} /> Loop</label>
                            </div>
                            <div className="col-12 py-2">
                                <label>Preload</label>
                                <select className="form-control" value={preload} onChange={e => setPreload(e.target.value)}>
                                    <option value="none">none</option>
                                    <option value="metadata">metadata</option>
                                    <option value="auto">auto</option>
                                </select>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="success" disabled={!habilitaInserir} onClick={confirmar}>inserir</Button>
            </ModalFooter>
        </Modal>
    );
};

export default InsertInstagram;
